function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
module.exports = function (app, mod, nft_overlay) {
  var _nft$slip;
  var can_merge = false;
  var all_slips = nft_overlay.nft.returnAllSlips() || [];
  var nft = nft_overlay.nft;
  nft_overlay.all_slips = all_slips;
  if (nft.getSlipCount() > 1 && mod.publicKey == nft.slip2.public_key) {
    can_merge = true;
  }
  var isPresent = function isPresent(v) {
    if (v == null) {
      return false;
    }
    var s = String(v).trim();
    return s !== '' && s !== 'N/A';
  };
  var escapeHtml = function escapeHtml(v) {
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };
  var infoRow = function infoRow(label, value) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$mono = _ref.mono,
      mono = _ref$mono === void 0 ? true : _ref$mono,
      _ref$prose = _ref.prose,
      prose = _ref$prose === void 0 ? false : _ref$prose;
    if (!isPresent(value)) {
      return '';
    }
    var valueClass = ['nft-info-value', mono ? 'nft-info-value-mono' : '', prose ? 'nft-info-value-prose' : ''].filter(Boolean).join(' ');
    return "\n      <div class=\"nft-info-row\">\n        <div class=\"nft-info-label\">".concat(escapeHtml(label), "</div>\n        <div class=\"").concat(valueClass, "\">").concat(escapeHtml(value), "</div>\n      </div>\n    ");
  };
  var nft_id = (nft === null || nft === void 0 ? void 0 : nft.id) || '';
  var creator = (nft === null || nft === void 0 ? void 0 : nft.creator) || (nft === null || nft === void 0 || (_nft$slip = nft.slip1) === null || _nft$slip === void 0 ? void 0 : _nft$slip.public_key) || '';
  var creationInfo = nft_overlay.decodeSlip3CreationInfo();
  var block_id = creationInfo.block_id;
  var tx_ordinal = creationInfo.tx_ordinal;
  var createdInDisplay = isPresent(block_id) && isPresent(tx_ordinal) ? "Block ".concat(block_id, " \xB7 Transaction ").concat(tx_ordinal) : '';
  var metadata = nft_overlay.extractMetadata();
  var metadataRows = '';
  for (var key in metadata) {
    var value = metadata[key];
    if (value == null || value === '') {
      continue;
    }
    if (_typeof(value) === 'object') {
      value = JSON.stringify(value, null, 2);
    }
    if (!isPresent(value)) {
      continue;
    }
    metadataRows += infoRow(key, value, {
      mono: true,
      prose: String(value).includes('\n')
    });
  }
  var infoTableHtml = "\n    <div class=\"nft-info-table\">\n      ".concat(infoRow('NFT ID', nft_id), "\n      ").concat(infoRow('Created By', creator), "\n      ").concat(infoRow('Created In', createdInDisplay, {
    mono: false
  }), "\n      ").concat(infoRow('Description', nft.description, {
    mono: false,
    prose: true
  }), "\n      ").concat(metadataRows, "\n    </div>\n  ");
  var mergeButtonHtml = can_merge ? "<button class=\"saito-button-primary saito-nft-footer-btn merge\">Merge</button>" : '';
  if (!all_slips.length) {
    all_slips.push(nft_overlay.nft);
  }
  var canDeleteFooter = all_slips.some(function (slip) {
    var _slip$slip;
    return mod.publicKey == ((_slip$slip = slip.slip2) === null || _slip$slip === void 0 ? void 0 : _slip$slip.public_key);
  });
  var deleteFooterHtml = canDeleteFooter ? "<button type=\"button\" class=\"saito-button-secondary saito-nft-footer-btn nft-info-delete-nft\">Delete</button>" : '';
  var footerSpacerHtml = "<span class=\"saito-nft-footer-spacer\"></span>";
  var splitUtxosHtml = '';
  var splitSlidersHtml = '';
  if (all_slips.length > 0) {
    for (var z = 0; z < all_slips.length; z++) {
      var utxoIdx = z + 1;
      var slip = all_slips[z];
      var uuid = '';
      if (slip.slip1) {
        var blockId = slip.slip1.block_id;
        var txOrdinal = slip.slip1.tx_ordinal;
        var slipIndex = slip.slip1.slip_index;
        if (isPresent(blockId) && isPresent(txOrdinal) && slipIndex !== undefined) {
          uuid = "".concat(blockId, "-").concat(txOrdinal, "-").concat(slipIndex);
        }
      }
      var amount = Number(slip.slip1.amount) || 0;
      var deposit = app.wallet.convertNolanToSaito(slip.slip2.amount);
      var splitButtonHtml = '',
        depositButtonHtml = '',
        deleteButtonHtml = '';
      if (mod.publicKey == slip.slip2.public_key) {
        deleteButtonHtml = "<button type=\"button\" class=\"utxo-delete-btn\" data-utxo-idx=\"".concat(utxoIdx, "\">Delete</button>");
      }
      if (amount > 1 && mod.publicKey == slip.slip2.public_key) {
        splitButtonHtml = "<button type=\"button\" class=\"utxo-split-btn\" data-utxo-idx=\"".concat(utxoIdx, "\">split</button>");
      }
      if (false && slip.slip2.public_key) {
        depositButtonHtml = "<button type=\"button\" class=\"utxo-deposit-btn\" data-utxo-idx=\"".concat(utxoIdx, "\">deposit</button>");
      }
      var slipRows = [isPresent(uuid) ? "<div class=\"nft-slip-box-row\">\n              <div class=\"nft-slip-box-label\">UUID</div>\n              <div class=\"nft-slip-box-value nft-slip-box-value-mono\">".concat(escapeHtml(uuid), "</div>\n            </div>") : '', "<div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">Units</div>\n            <div class=\"nft-slip-box-value\">".concat(escapeHtml(slip.slip1.amount), "</div>\n          </div>"), "<div class=\"nft-slip-box-row\">\n            <div class=\"nft-slip-box-label\">Deposit</div>\n            <div class=\"nft-slip-box-value\">".concat(escapeHtml(deposit), " SAITO</div>\n          </div>")].join('');
      var actionsHtml = deleteButtonHtml || depositButtonHtml || splitButtonHtml ? "<div class=\"nft-slip-box-actions\">\n              ".concat(deleteButtonHtml, "\n              ").concat(depositButtonHtml, "\n              ").concat(splitButtonHtml, "\n            </div>") : '';
      splitUtxosHtml += "\n        <div class=\"nft-slip-box utxo-".concat(utxoIdx, "\" id=\"utxo_").concat(utxoIdx, "\">\n          <div class=\"nft-slip-box-index\">Slip ").concat(utxoIdx, "</div>\n          ").concat(slipRows, "\n          ").concat(actionsHtml, "\n        </div>\n      ");
      splitSlidersHtml += "\n        <div class=\"saito-nft-split-overlay split-container-utxo-".concat(utxoIdx, "\" data-utxo-idx=\"").concat(utxoIdx, "\">\n          <div class=\"split-instructions\">\n            Adjust this slider to manually split your NFT into two parts. When you are happy with the new allocation, click the \"split\" button to make the transaction that divides it.\n          </div>\n          <div class=\"split-slider-wrapper\">\n            <div class=\"split-number-box split-number-left-utxo-").concat(utxoIdx, "\" id=\"split-number-left-utxo-").concat(utxoIdx, "\">0</div>\n            <div class=\"fancy-slider-bar\" id=\"split-slider-utxo-").concat(utxoIdx, "\">\n              <div class=\"split-half split-half-left split-left-utxo-").concat(utxoIdx, "\" id=\"split-left-utxo-").concat(utxoIdx, "\"></div>\n              <div class=\"split-bar split-bar-utxo-").concat(utxoIdx, "\" id=\"split-bar-utxo-").concat(utxoIdx, "\"></div>\n              <div class=\"split-half split-half-right split-right-utxo-").concat(utxoIdx, "\" id=\"split-right-utxo-").concat(utxoIdx, "\"></div>\n            </div>\n            <div class=\"split-number-box split-number-right-utxo-").concat(utxoIdx, "\" id=\"split-number-right-utxo-").concat(utxoIdx, "\">0</div>\n          </div>\n          <div class=\"split-buttons-container\">\n            <button class=\"split-button split-return-button split-return-button-utxo-").concat(utxoIdx, "\">Cancel</button>\n            <div class=\"split-buttons-right\">\n              <button class=\"split-button split-button-utxo-").concat(utxoIdx, "\">split</button>\n            </div>\n          </div>\n        </div>\n      ");
    }
  }
  var slipsContainerHtml = '';
  if (all_slips.length > 0) {
    slipsContainerHtml = "\n      <div class=\"nft-slips-container\">\n        <div class=\"nft-slips-title\">UTXO / Slips</div>\n        <div class=\"nft-slips-flex\">\n          ".concat(splitUtxosHtml, "\n        </div>\n      </div>\n    ");
  }
  return "\n    <div class=\"saito-nft-panel saito-nft-panel-info\">\n      <div class=\"saito-nft-panel-body\">\n        ".concat(infoTableHtml, "\n        ").concat(slipsContainerHtml, "\n        ").concat(splitSlidersHtml, "\n      </div>\n      <div class=\"saito-nft-split-utxo\"></div>\n      <footer class=\"saito-nft-panel-footer\">\n        <button type=\"button\" class=\"saito-button-square saito-nft-info-back\" aria-label=\"Back\">\n          <i class=\"fa-solid fa-arrow-left\" aria-hidden=\"true\"></i>\n        </button>\n        ").concat(footerSpacerHtml, "\n        ").concat(deleteFooterHtml, "\n        ").concat(mergeButtonHtml, "\n      </footer>\n    </div>\n  ");
};